import PropTypes from 'prop-types'

export const DeviceName = ({ type, deviceTypes }) => {
  const devices = []
  if (deviceTypes.includes('MOBILE')) {
    devices.push('모바일')
  }
  if (deviceTypes.includes('PC')) {
    devices.push('PC')
  }
  return type === 'ALL' ? '전체' : <>{devices.join(', ')}</>
}
DeviceName.propTypes = {
  type: PropTypes.string.isRequired,
  deviceTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
}
export default DeviceName
